const modules = {
  register: {
    insurances: false,
    favorites: true,
  },
  drawer: {
    partners: false,
    emergencyPetCareRelay: false,
  },
  contact: {
    liveChat: true,
  },
  others: {
    ThirtyMillionsFriends: true,
    emergencyPetCareRelay: false,
  },
  missingImages: false,
}

export default modules
